import { getIconSize } from '@cdab/utils'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import type { AuditBottomNavigationStyleProps } from './audit-bottom-navigation.styles.types'

export const BOTTOM_NAVIGATION_HEIGHT = '70px'
const TRANSITION_DURATION = '250ms'

export const VariableProvider = styled.div`
  --safe-inset-bottom: env(safe-area-inset-bottom);
  --bottom-navigation-height: calc(
    ${BOTTOM_NAVIGATION_HEIGHT} + var(--safe-inset-bottom)
  );
`

export const BottomSticky = styled.div<AuditBottomNavigationStyleProps>`
  position: absolute;
  background-color: var(--tds-blue-700);
  z-index: 9999;

  transition-timing-function: cubic-bezier(0.1, 0.7, 0.6, 0.9);
  transition-property: all;
  transition-duration: ${TRANSITION_DURATION};

  height: calc(100% - var(--bottom-navigation-height));
  width: 100%;

  left: 0;
  top: 0;
  transform: translateY(100%);

  display: flex;
  flex-direction: column;

  ${({ isOpen }) =>
    isOpen &&
    css`
      box-shadow: rgb(0 0 0 / 30%) 0 0 10px;
      transform: translateY(0);
    `};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
`

export const IconButton = styled.button.attrs({
  className: 'primary sc-tds-button sc-tds-button-h sc-tds-button-s'
})`
  tds-icon {
    height: ${getIconSize('medium')};
    width: ${getIconSize('medium')};
  }

  &&& {
    display: flex;
    align-items: center;
    height: 100%;
    padding: var(--tds-spacing-element-8);
    color: var(--tds-white);
    border: 1px solid;
    border-color: var(--tds-grey-500);
    border-radius: 4px !important;
    box-shadow: 'none' !important;
    background-color: var(--tds-btn-secondary-background);
  }
  :focus {
    background-color: var(--tds-btn-primary-background-focus);

    outline: 2px solid var(--tds-blue-400);
  }
`

export const Navigation = styled.div`
  z-index: 9999;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: var(--tds-blue-700);
  display: flex;
  flex-direction: row;
  padding: var(--tds-spacing-layout-16);
  padding-bottom: calc(var(--tds-spacing-layout-16) + var(--safe-inset-bottom));
  height: var(--bottom-navigation-height);

  > div {
    display: flex;
    flex: 1;
    justify-content: center;

    &:first-child {
      justify-content: flex-start;
    }

    &:last-child {
      justify-content: flex-end;
    }
  }
`

export const Dropshadow = styled.div<AuditBottomNavigationStyleProps>`
  visibility: ${({ isOpen }) => (isOpen ? 'isOpen' : 'hidden')};
  opacity: ${({ isOpen }) => (isOpen ? '0.6' : '0')};
  transition: ${TRANSITION_DURATION};
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.1, 0.7, 0.6, 0.9);

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 9999;
`

export const StyledLink = styled(Link)`
  text-decoration: none;
`

export const SummaryLinkItem = styled.div`
  background: var(--tds-blue-600);
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-around;

  padding: var(--tds-spacing-element-16) var(--tds-spacing-element-8);

  &:active {
    background: var(--tds-btn-primary-background-active);
  }
`
export const SummaryLinkItemLeft = styled.div`
  display: flex;
  flex: 1;
  width: var(--tds-spacing-element-16);
`
export const SummaryLinkItemCenter = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`
export const SummaryLinkItemRight = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`
